export const SET_USER = 'SET_USER';

export const setUser = (data) => ({
  type: SET_USER,
  payload: data,
});
